import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { MessageWrapper } from '../Styles';
import { copyToClipboard } from '../utils';
export const CopyLogButton = observer(() => {
  const {
    DebuggerStore: { logCount, logData },
  } = useStores();

  if (logCount === 0) return null;

  return (
    <MessageWrapper
      bgColor="#ff0"
      color="#000"
      onClick={() => copyToClipboard(JSON.stringify(logData))}
      style={{ cursor: 'pointer' }}
      title="CLICK TO COPY THE CURRENT SIMULCAST LOG FROM LOCAL STORAGE TO THE CLIPBOARD."
    >
      Copy Log
    </MessageWrapper>
  );
});

export default CopyLogButton;
